export const tedVideosList = [
    {
        title: "TEDxVANCOUVER TALK: a BALL Story!",
        year: "2010",
        url: "http://youtu.be/gLH32WHfeJI",
    },
    {
        title: "TED FULL SPECTRUM AUDITIONS FINALIST: We All Speak BALL!",
        year: "2011",
        url: "http://blog.ted.com/2011/05/09/announcing-the-finalists-in-teds-full-spectrum-auditions/",
    },
    {
        title: "TED FULL SPECTRUM FINALS BLOG INTERVIEW",
        year: "2011",
        url: "http://blog.ted.com/2011/05/26/we-all-speak-ball-qa-with-full-spectrum-speaker-kevin-carroll/",
    },
    {
        title: "TEDxHARLEM TALK: PLAY is Necessary!",
        year: "2012",
        url: "http://youtu.be/1pz72Wygg8c",
    },
    {
        title: "TEDxRVA TALK: PLAY is...",
        year: "2013",
        url: "http://youtu.be/lWpfnUdq7Iw",
        place: "Richmond, VA",
    },
    {
        title: "TEDxAustinWOMEN TALK: The power + magic of Matriarchs!",
        year: "2013",
        url: "http://m.youtube.com/watch?list=PLsRNoUx8w3rNulgOz5WrEG6EPhXE63GZO&feature=plpp&v=wiXpVamxxoU",
    },
    {
        title: "TEDxOU TALK: TAKE A STAND FOR PLAY!",
        year: "2014",
        url: "https://youtu.be/qH2_H9vnjW0",
        place: "University of Oklahoma",
    },
];